import { useState, useEffect } from "react";
import { LocalStorageKeys } from "types/enums";

export const useOfflineAuthenticatedStatus = (): boolean => {
  const userRoles = localStorage.getItem(LocalStorageKeys.UserRoles);
  const organizationUserId = localStorage.getItem(
    LocalStorageKeys.OrganizationUserId
  );

  const isOfflineAuthenticated = Boolean(
    userRoles &&
      userRoles.trim() !== "" &&
      organizationUserId &&
      organizationUserId.trim() !== ""
  );

  return isOfflineAuthenticated;
};
